import client from '../../../helpers/client';
import cognito from '../../../helpers/cognito';

export const getListCodebaseByDao = (params) => {
  return async () => {
    const { daoId, chainId, page, limit } = params;
    const queryParams = new URLSearchParams({
      daoId,
      chainId,
      page,
      limit
    }).toString();
    
    return client
      .api(`/codebase/get-codebases-by-dao?${queryParams}`, 'get', {
        headers: await cognito.getHeaderAuthorization()
      })
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};

export const getDetailCodebase = (codebaseId) => {
  return async () => {
    return client
      .api(`/code-bases/${codebaseId}`, 'get', {
        headers: await cognito.getHeaderAuthorization()
      })
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};

export const createRound = (data) => {
  return async () => {
    return client
      .api('/challenge-rounds', 'post', data,
        { headers: await cognito.getHeaderAuthorization() }
      )
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};

export const updateCodeBase = ({ codeBaseId, data }) => {
  return async () => {
    return client.api(`/code-bases/${codeBaseId}`, 'put', data,
      { headers: await cognito.getHeaderAuthorization() }
    ).then(({ data: response }) => {
      return response;
    }).catch((err) => {
      return null;
    });
  };
};